import React, {Component} from 'react';
import FieldLabel from './field-label';
import FieldHelpText from './field-help-text';
import FieldMandatory from './field-mandatory';
import FieldWidth from './field-width';
import ConditionId from './condition-id';

export default class NumberField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model || {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <div>
      <FieldLabel value={this.state.model.label} onChange={v => this.updateModel('label', v)} />
      <div className="mb-3">
        <label htmlFor="placeholder" className="form-label">Placeholder</label>
        <input id="placeholder" name="placeholder"
               type="text"
               className="form-control"
               value={this.state.model.placeholder || ''}
               onChange={e => this.updateModel('placeholder', e.target.value)} />
        <div className="form-text">Short hint, will appear in the field before it is filled out.</div>
      </div>
      <FieldHelpText value={this.state.model.helpText} onChange={v => this.updateModel('helpText', v)} />
      <FieldMandatory id={this.props.id}
                      value={this.state.model.mandatory}
                      onChange={v => this.updateModel('mandatory', v)}
                      conditionallyDisplayed={!!this.state.model.conditionId}/>
      <FieldWidth value={this.state.model.widthInPercent} onChange={v => this.updateModel('widthInPercent', v)} />
      <ConditionId id={this.props.id}
                   conditions={this.state.conditions}
                   value={this.state.model.conditionId}
                   onChange={v => this.updateModel('conditionId', v)}/>
    </div>
  }

}
